import React, { useState } from 'react';
import { Package, MapPin, Trash2, Plus, FileText, History, RotateCcw, SlidersHorizontal } from 'lucide-react';
import InventoryLocationsView from './InventoryLocationsView';
import ItemsView from './ItemsView';
import UOMView from './UOMView';
import VariantAttributesView from './VariantAttributesView';

export default function InventoryDashboardView({ orgId, language = 'en', initialItemId, onClearInitial, onNavigate }: { orgId: string, language?: string, initialItemId?: string | null, onClearInitial?: () => void, onNavigate?: (tab: string, id: string) => void }) {
  const tabs = [
    { id: 'all', label: 'Products & Services', icon: Package },
    { id: 'variants', label: 'Product Variant', icon: SlidersHorizontal },
    { id: 'uom', label: 'UOM', icon: RotateCcw },
    { id: 'categories', label: 'Categories', icon: Package },
    { id: 'warehouses', label: 'Warehouses', icon: MapPin },
    { id: 'lots', label: 'Lot Numbers', icon: Package },
    { id: 'scrap', label: 'Scrap', icon: Trash2 },
  ] as const;

  const [activeTab, setActiveTab] = useState<'all' | 'variants' | 'uom' | 'categories' | 'warehouses' | 'lots' | 'scrap'>('all');

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Inventory</h1>
          <p className="text-sm opacity-50 italic serif mt-1">Manage your stock, warehouses and movements</p>
        </div>
      </div>

      {/* Header and horizontal nav */}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between bg-white border border-[#141414] p-2 rounded-2xl">
        <div className="flex overflow-x-auto w-full hide-scrollbar">
           {tabs.map(tab => {
             const Icon = tab.icon;
             return (
               <button
                 key={tab.id}
                 onClick={() => setActiveTab(tab.id)}
                 className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                   activeTab === tab.id ? 'bg-[#141414] text-white' : 'text-gray-600 hover:bg-gray-100'
                 }`}
               >
                 <Icon className="w-4 h-4" />
                 {tab.label}
               </button>
             );
           })}
        </div>
      </div>

      <div>
        {activeTab === 'uom' ? (
          <UOMView orgId={orgId} language={language} />
        ) : activeTab === 'variants' ? (
          <VariantAttributesView orgId={orgId} language={language} />
        ) : (
          <ItemsView 
            orgId={orgId} 
            language={language} 
            isInventoryMode={true} 
            initialFilter="inventory" 
            initialSubTab={activeTab as any} 
            initialItemId={initialItemId}
            onClearInitial={onClearInitial}
            onNavigate={onNavigate}
          />
        )}
      </div>
    </div>
  );
}
